import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

import en from '@admin/translations/en.json';
import fr from '@admin/translations/fr.json';

const translations: Record<string, TranslationObject> = { en, fr } as Record<string, TranslationObject>;

export class StaticTranslateLoader implements TranslateLoader {
    public getTranslation(lang: string): Observable<TranslationObject> {
        return of(translations[lang] ?? ({} as TranslationObject));
    }
}
